export const CHANGE_QUOTATION_PRODUCTS = 'CHANGE_QUOTATION_PRODUCTS';
export const UPDATE_ARTICLE_NUMBERS_LIST = 'UPDATE_ARTICLE_NUMBERS_LIST';
export const UPDATE_LIST_OF_PRODUCTS = 'UPDATE_LIST_OF_PRODUCTS';
export const UPDATE_FORM_DETAILS = 'UPDATE_FORM_DETAILS';
export const UPDATE_RESPONSE = 'UPDATE_RESPONSE';
export const SET_SUBMIT_STATE = 'SET_SUBMIT_STATE';
export const SET_TERMS_ACCEPT_STATE = 'SET_TERMS_ACCEPT_STATE';
export const SET_ERROR_STATE = 'SET_ERROR_STATE';

export const DEFAULT_FORM_DATA =
{
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    address: '',
    zipCode: '',
    city: '',
    organizationNumber: '',
    contactPerson: '',
}


/**
 * 
 * @param {int} count
 */
export const amountOfProducts = count => dispatch => {
    return dispatch({
        type: CHANGE_QUOTATION_PRODUCTS,
        payload: {
            count: count,
        },
    });
};

/**
 * 
 * @param {object} formDetails
 */
export const updateFormDetails = (formDetails) => (dispatch) => {
    return dispatch({
        type: UPDATE_FORM_DETAILS,
        payload: {
            formDetails: formDetails,
        },
    });
};

/**
 * 
 * @param {object} payload
 */
export const updateResponse = (payload) => (dispatch) => {
    return dispatch({
        type: UPDATE_RESPONSE,
        payload: payload,
    });
};

/**
 * 
 * @param {object} errors
 */
export const setErrorState = (errors) => (dispatch) => {
    return dispatch({
        type: SET_ERROR_STATE,
        payload: {
            errors: errors,
        },
    });
};

/**
 *
 * @param {object} termsAccepted
 */
export const setTermsAcceptState = (termsAccepted) => (dispatch) => {
    return dispatch({
        type: SET_TERMS_ACCEPT_STATE,
        payload: {
            termsAccepted: termsAccepted
        },
    });
};

/**
 *
 * @param {bool} state
 */
export const setSubmitState = (state) => (dispatch) => {
    return dispatch({
        type: SET_SUBMIT_STATE,
        payload: {
            submitState: state
        },
    });
};